import notifierMixin from './notifierMixin';

export default {
  computed: {
    /**
     * @description Выбран кабинет.
     * @type {boolean}
     */
    wasSelectedCabinet: ({ cabinet }) => !!cabinet,
  },
  data() {
    return {
      /**
       * @description Выбранный кабинет.
       * @type {any}
       */
      cabinet: null,
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      cabinetInputErrors: {},
    };
  },
  methods: {

    /**
     * @description Получить кабинет.
     * @param {number} cabinetId Идентификатор кабинета.
     * @returns {Promise}
     */
    fetchCabinet(cabinetId) {
      const onFail = ({ title }) => { this.notifyFail(title); };
      const onSuccess = (cabinet) => {
        this.cabinet = cabinet;
        this.cabinetInputErrors = {};
      };
      const response = this.$cabinetGateway.getById(cabinetId);
      response.then((result) => result.fold(onFail, onSuccess));
      return response;
    },

    /**
     * @description Отправить запрос на редактирование данных кабинета.
     * @param {any} request Запрос.
     * @returns {Promise<Either>}
     */
    async sendEditCabinetRequest(request) {
      const onFail = (error) => {
        this.cabinetInputErrors = error.allCauses();
        if (!error.hasCauses()) {
          this.notifyFail(error.getTitle());
        }
      };
      const response = await this.$cabinetGateway.sendEditCabinet(request);
      response.forEachLeft(onFail);
      return response;
    },
  },
  mixins: [notifierMixin],
};
